export default __webpack_public_path__ + "static/media/AppPerkViews.d7c4600c.png";